module.exports = __webpack_public_path__ + "img/Check-mark.5ed4dcca.svg";